import useOperationSummary from 'hooks/useOperationSummary';
import {
  OperationSummaryError,
  OperationSummaryParams
} from 'components/RecordsListView/types';
import getSummaryInvoices from '../helpers/getSummaryInvoices';
import { InvoiceSummary } from '../types';

export interface UseInvoicesSummaryReturn {
  loading: boolean;
  invoices: InvoiceSummary[];
  totalElements: number;
  totalPages: number;
  pageSize: number;
  currentPage: number;
  numberOfElements: number;
  loadInvoices: () => Promise<void>;
  errors?: OperationSummaryError | null;
  /** Crop seasons the held invoices were fetched for; undefined until the first response. */
  loadedCropSeasonIds?: string[];
}

/**
 * Invoice adapter over the operation-agnostic `useOperationSummary`. Wires the
 * generic summary hook to the invoice fetch fn and re-exports the result with
 * invoice-named fields (`invoices`/`loadInvoices`) so the redesigned invoice
 * layer reads naturally. Mirrors `useApplicationsSummary`.
 */
const useInvoicesSummary = (
  params?: OperationSummaryParams
): UseInvoicesSummaryReturn => {
  const {
    loading,
    items: invoices,
    totalElements,
    totalPages,
    pageSize,
    currentPage,
    numberOfElements,
    loadItems: loadInvoices,
    errors,
    loadedCropSeasonIds
  } = useOperationSummary<InvoiceSummary>(
    'invoicesSummary',
    getSummaryInvoices,
    params,
    'invoicesSummary'
  );

  return {
    loading,
    invoices,
    totalElements,
    totalPages,
    pageSize,
    currentPage,
    numberOfElements,
    loadInvoices,
    errors,
    loadedCropSeasonIds
  };
};

export default useInvoicesSummary;
